import { Core } from "@faire/design-tokens";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled from "styled-components";

interface IProps {
  className?: string;
  listRank: string;
  title: string;
  body: string;
}

export const AmexHowFaireWorksListItem: React.FC<IProps> = ({
  className,
  listRank,
  title,
  body,
}) => {
  return (
    <Wrapper className={className}>
      <NumberLabel>{listRank}</NumberLabel>
      <RightColumn>
        <Title>{title}</Title>
        <Body>{body}</Body>
      </RightColumn>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 30px auto;
  grid-template-rows: auto auto;
  grid-gap: 0 16px;
`;

const NumberLabel = styled(Typography).attrs({
  color: Core.text.subdued,
  variant: "subheadingSansMedium",
})`
  grid-row: 1/3;
  grid-column: 1/2;
  line-height: 24px;
`;

const RightColumn = styled.div`
  text-align: left;
`;

const Title = styled(Typography).attrs({
  color: Core.text.default,
  variant: "subheadingSansMedium",
})`
  line-height: 24px;
`;

const Body = styled(Typography).attrs({
  color: Core.text.subdued,
})`
  &&& {
    line-height: 20px;
    margin: 12px 0 0 0;
    ${responsiveMediaQueries.tabletAndAbove} {
      margin: 8px 0 0 0;
    }
  }
`;
